module.exports = __webpack_public_path__ + "static/img/shangqingwan.a3c79c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/shangqingwan.png
// module id = 8STz
// module chunks = 1